// Een vragenlijst bewaart sectiekoppen (`Type: 'section'`) als gewone
// QuestionnaireFields-documenten, tussen de vragen in. Ze hebben geen antwoorden,
// dus elke lijst die vragen met hun resultaten toont moet ze overslaan — anders
// belanden ze in DataType en staat er 'Unknown type'.

/**
 * @typedef {object} QuestionnaireFieldLike
 * @property {string} [Type] - Vraagsoort; 'section' voor een sectiekop
 */

/**
 * @param {QuestionnaireFieldLike | null | undefined} field - Een QuestionnaireFields-doc
 * @returns {boolean} True als het een echte vraag is, geen sectiekop.
 */
const isQuestionField = (field) => Boolean(field) && field.Type !== 'section'

export default isQuestionField
